import React from "react";
import { useTranslation } from "hooks";
import { Typography } from "components";
import icon from "./Empty.svg";
import styles from "./Empty.module.css";

const Empty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <img src={icon} alt="No downloaded assignments" className={styles.img} />
      <Typography variant="p2">{t("offline.noDownloaded")}</Typography>
    </div>
  );
};

export default Empty;
